<template>
  <v-icon
    class="mt-2"
    color="darkslategray"
  >
    {{ icon }}
  </v-icon>
</template>

<script>
const ASSET_ICONS = {
  realProperty: 'building-house',
  intellectualProperty: 'file',
  sharesInvestments: 'file',
  generalGoods: 'car',
  digitalAssets: 'chip',
  uncategorised: 'package',
  confidentialityAgreement: 'file'
}

function getAssetIcon(assetType) {
  return ASSET_ICONS[assetType] ? ASSET_ICONS[assetType] : 'package'
}

export default {
  name: 'AssetIcon',
  props: {
    assetType: { type: String, required: true }
  },
  computed: {
    icon() {
      return `bx-${getAssetIcon(this.assetType)}`
    }
  }
}
</script>
<style></style>
